__turbopack_context__.v({
  "indicator": "oEXHDG_indicator",
});
